export default __webpack_public_path__ + "static/media/welcome-complete.4ddb40c8.png";